var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgReplayVideo = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 104,
  height: 104,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#replay_video_svg__a)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 52,
  cy: 47,
  r: 30,
  fill: "#65A0F1"
}))), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M53.5 33.5A13.5 13.5 0 0 0 40 47h-4.5l5.94 6.045L47.5 47H43a10.5 10.5 0 1 1 10.5 10.5c-2.534 0-4.861-.908-6.67-2.412-.426-.354-1.058-.36-1.45.032l-.715.715c-.39.39-.393 1.024.023 1.386A13.334 13.334 0 0 0 53.5 60.5a13.5 13.5 0 1 0 0-27Z",
  fill: "#fff"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "replay_video_svg__a",
  x: 0.039,
  y: 0.039,
  width: 103.922,
  height: 103.922,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 5
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 10.98
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_5943_135397"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_5943_135397",
  result: "shape"
})))));
export default SvgReplayVideo;